var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineMusicDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 21.5v-19c0-.41.34-.75.75-.75s.75.34.75.75v19c0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.23 15.31a2.25 2.25 0 0 1 2.24-2.24 2.25 2.25 0 0 1 2.24 2.24 2.25 2.25 0 0 1-2.24 2.24c-1.24 0-2.24-1.01-2.24-2.24zm1.5-.01c0 .41.33.74.74.74s.74-.33.74-.74-.34-.74-.74-.74c-.41 0-.74.33-.74.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.21 15.31V9.3c0-.92.58-1.68 1.47-1.92l2.98-.81c.92-.25 1.5-.01 1.82.24.46.35.7.92.7 1.69v5.83c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8.5c0-.33-.07-.47-.11-.49-.05-.04-.22-.06-.51.02l-2.98.81c-.24.07-.36.22-.36.48v6.01c-.01.39-.35.73-.76.73-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.69 14.31c0-1.24 1.01-2.24 2.24-2.24a2.25 2.25 0 0 1 2.24 2.24c.01 1.24-1 2.24-2.24 2.24-1.24 0-2.24-1.01-2.24-2.24zm1.5 0c0 .41.33.74.74.74s.74-.33.74-.74-.33-.74-.74-.74-.74.33-.74.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.24 11.24a.75.75 0 0 1 .53-.92l5.47-1.49a.75.75 0 1 1 .39 1.45l-5.47 1.49c-.07.01-.14.02-.2.02-.33 0-.63-.22-.72-.55z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMusicDashboard);
export default __webpack_public_path__ + "static/media/vuesax-outline-music-dashboard.caef075692ce0fc573f94c97d0027ed5.svg";
export { ForwardRef as ReactComponent };